import { ECndnReason, ECndnType } from '@/enums/ECndn';
import { IColor } from '@/interfaces/color';

const getCndnTypeName = (status: ECndnType): string => {
  switch (status) {
    case ECndnType.CREDIT:
      return 'ลดหนี้';
    case ECndnType.DEBIT:
      return 'เพิ่มหนี้';
    case ECndnType.CREDIT_RETURN:
      return 'ลดหนี้คืนสินค้า';
  }
};

const getCndnColor = (status: ECndnType): IColor => {
  let color: IColor = {
    bg: 'bg-blue-200',
    text: 'text-black',
  };
  switch (status) {
    case ECndnType.DEBIT:
      color = {
        bg: 'bg-green-100',
        text: 'text-green-700',
      };
      break;
  }
  return color;
};

const getCndnReasonName = (status: ECndnReason): string => {
  switch (status) {
    case ECndnReason.RETURN_GOOD:
      return 'คืนสินค้า';
    case ECndnReason.CREDIT_PRICE:
    case ECndnReason.DEBIT_PRICE:
      return 'ปรับราคา';
  }
};

const getCndnTypeOptions = () =>
  Object.entries(ECndnType)
    .filter(([key]) => isNaN(Number(key)) && key !== 'CREDIT_RETURN')
    .map(([, value]) => ({
      label: getCndnTypeName(value as ECndnType),
      value: value as ECndnType,
    }));
const getCndnTypeOptionsWithCreditReturn = () =>
  Object.entries(ECndnType)
    .filter(([key]) => isNaN(Number(key)))
    .map(([, value]) => ({
      label: getCndnTypeName(value as ECndnType),
      value: value as ECndnType,
    }));

export {
  getCndnTypeName,
  getCndnColor,
  getCndnTypeOptions,
  getCndnReasonName,
  getCndnTypeOptionsWithCreditReturn,
};
